module.exports = "pegasus/assets/blocks/column-6-tech.png";